export function extractLegalCounts(propertyData) {
  const props =
    propertyData?.gn_properties ||
    propertyData?.properties ||
    propertyData?.data?.gn_properties ||
    propertyData?.data?.properties ||
    {};
  const key = Object.keys(props).find((k) => k.toLowerCase() === 'legal');
  const data = key ? props[key] : null;
  const list = Array.isArray(data) ? data : data ? [data] : [];

  let totalCivis = 0;
  let totalCriminais = 0;

  for (const entity of list) {
    if (!entity || typeof entity !== 'object') continue;
    const civilStatus = entity?.civilstatus;
    const criminalStatus = entity?.criminalstatus;

    const civil = Array.isArray(civilStatus)
      ? civilStatus.flatMap((entry) => (Array.isArray(entry?.processos) ? entry.processos : []))
      : Array.isArray(civilStatus?.processos)
        ? civilStatus.processos
        : [];

    const crim = Array.isArray(criminalStatus)
      ? criminalStatus.flatMap((entry) => (Array.isArray(entry?.processos) ? entry.processos : []))
      : Array.isArray(criminalStatus?.processos)
        ? criminalStatus.processos
        : [];

    totalCivis += civil.filter((p) => p?.tipo_processo === 'CIVIL').length;
    totalCriminais += crim.filter((p) => p?.tipo_processo === 'CRIMINAL').length;
    // Alguns cenários podem ter processos criminais listados em civilstatus
    totalCriminais += civil.filter((p) => p?.tipo_processo === 'CRIMINAL').length;
  }

  return { totalCivis, totalCriminais };
}
